module.exports = __webpack_public_path__ + "static/media/wizards-of-the-coast.5f3d4386.svg";